import { Anchor, type AnchorProps } from '@mantine/core';
import type { ComponentPropsWithoutRef, ComponentType, ElementType, JSX } from 'react';

type TableAnchorProps = AnchorProps &
  Omit<ComponentPropsWithoutRef<'a'>, keyof AnchorProps> & {
    component?: ElementType;
    to?: string;
    type?: string;
    disabled?: boolean;
  };

// Mantine's `Anchor` is polymorphic via its `component` prop. The internal
// discriminated-union typing makes a thin wrapper hard to type precisely, so
// we cast through `ComponentType<TableAnchorProps>` at the module boundary —
// runtime behaviour is identical, call sites still see a typed surface.
const TypedAnchor = Anchor as unknown as ComponentType<TableAnchorProps>;

export function TableAnchor(props: TableAnchorProps): JSX.Element {
  return <TypedAnchor fw="bold" underline="always" c="polaris" {...props} />;
}
